import React from 'react';

const PrivacyPolicyModal = ({ isOpen, onClose, onAccept }) => {
  if (!isOpen) return null;

    const email = process.env.REACT_APP_CONTACT_MAIL
  const phone = process.env.REACT_APP_CONTACT_PHONE


  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative bg-white rounded-lg max-w-3xl w-full max-h-[80vh] overflow-hidden shadow-xl">
          {/* Header */}
          <div className="px-6 py-4 border-b border-gray-200 bg-gray-50">
            <h3 className="text-xl font-semibold text-gray-900">
              Privacy Policy
            </h3>
          </div>
          
          {/* Content - scrollable */}
          <div className="px-6 py-4 overflow-y-auto max-h-[60vh]">
            <div className="space-y-4 text-sm text-gray-700">
              <section>
                <h4 className="font-semibold text-gray-900 mb-2">
                  1. Information We Collect
                </h4>
                <p>When you submit this contact form, we may collect:</p>
                <ul className="list-disc pl-5 mt-2 space-y-1">
                  <li>Your name and contact information (email, phone)</li>
                  <li>Company name and position</li>
                  <li>Country of origin</li>
                  <li>Message content and inquiry details</li>
                  <li>Technical requirements you specify</li>
                </ul>

                <p className="mt-3">
                  If you prefer, you may contact us directly at{" "}
                  <span className="font-medium">{email}</span> or by phone at{" "}
                  <span className="font-medium">{phone}</span>.
                </p>
              </section>

              <section>
                <h4 className="font-semibold text-gray-900 mb-2">2. How We Use Your Information</h4>
                <p>We use your information solely to:</p>
                <ul className="list-disc pl-5 mt-2 space-y-1">
                  <li>Respond to your product inquiry</li>
                  <li>Provide technical specifications you requested</li>
                  <li>Communicate about your potential order</li>
                </ul>
              </section>

              <section>
                <h4 className="font-semibold text-gray-900 mb-2">
                  3. Data Storage & Processing
                </h4>
                <p>Your information is handled as follows:</p>
                <ul className="list-disc pl-5 mt-2 space-y-1">
                  <li>Transmitted securely via email (SMTP)</li>
                  <li>
                    <span className="font-semibold text-green-700">
                      We do NOT store
                    </span>{" "}
                    your personal data in any database on this website or server
                  </li>
                  <li>Only accessible to our technical team via email</li>
                  <li>Retained only within our email system for customer service purposes</li>
                </ul>
              </section>

              <section>
                <h4 className="font-semibold text-gray-900 mb-2">4. Data Sharing</h4>
                <p className="font-medium text-gray-900">We do not:</p>
                <ul className="list-disc pl-5 mt-2 space-y-1">
                  <li>Sell your personal information</li>
                  <li>Share your data with third parties for marketing</li>
                  <li>Use your information for automated decision-making</li>
                </ul>
              </section>

              <section>
                <h4 className="font-semibold text-gray-900 mb-2">5. Your Rights</h4>
                <p>You have the right to:</p>
                <ul className="list-disc pl-5 mt-2 space-y-1">
                  <li>Request access to your personal data</li>
                  <li>Request correction or deletion of your data</li>
                  <li>Withdraw consent at any time</li>
                </ul>
                <p className="mt-2">To exercise these rights, contact us at {email}</p>
              </section>

              <section>
                <h4 className="font-semibold text-gray-900 mb-2">6. Cookies & Tracking</h4>
                <p>This form does not set any tracking cookies. Our website may use essential cookies for functionality.</p>
              </section>
            </div>
          </div>
          
          {/* Footer with actions */}
          <div className="px-6 py-4 border-t border-gray-200 bg-gray-50 flex justify-end space-x-3">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Close
            </button>
            <button
              onClick={onAccept}
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              I Agree
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyModal;